module.exports = __webpack_public_path__ + "img/mat_2.42a5adbf.png";